import { Box } from '@mui/material'
import { C1Button, C1ButtonProps } from 'c1ui'
import { C1Icon } from 'components/core/icons/C1Icon'
import {
    EscalateToEmergencyAccessDialogV2,
} from 'components/pages/task/details/task-content-v2/common/EscalateToEmergencyAccessTaskDialog'
import { canActOn } from 'components/pages/task/state'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import { Zap } from 'lucide-react'
import { TaskActionType } from 'pbts/c1/api/task/v1/task'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

export const EscalateToEmergencyAccessButton: FC<C1ButtonProps & { task: TaskValue }> = ({ task, ...props }) => {
    const { open } = useSimpleModal()

    const handleClick = (): void => {
        open(EscalateToEmergencyAccessDialogV2, { task })()
    }

    if (!canActOn(task, TaskActionType.ESCALATE_TO_EMERGENCY_ACCESS)) {
        return null
    }

    return (
        <Box>
            <C1Button
                variant="outlined"
                onClick={handleClick}
                disabled={!canActOn(task, TaskActionType.ESCALATE_TO_EMERGENCY_ACCESS)}
                startIcon={<C1Icon icon={Zap} size="sm" />}
                {...props}
            >
                <FormattedMessage
                    id="components_task_review_access_diagram_request_emergency_access"
                    defaultMessage="Request emergency access"
                />
            </C1Button>
        </Box>
    )
}
